import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Speaking from "@/pages/Speaking";
import Workshops from "@/pages/Workshops";
import Coaching from "@/pages/Coaching";
import Shop from "@/pages/Shop";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/speaking" element={<Speaking />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
